import { render, staticRenderFns } from "./ImageUpload2.vue?vue&type=template&id=30217118&scoped=true"
import script from "./ImageUpload2.vue?vue&type=script&lang=js"
export * from "./ImageUpload2.vue?vue&type=script&lang=js"
import style0 from "./ImageUpload2.vue?vue&type=style&index=0&id=30217118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30217118",
  null
  
)

export default component.exports